// Styles

// import "../../scss/style.scss";
// Vuetify
import { createVuetify } from "vuetify";

import vuetifySetting from "./vuetifySetting";

export default createVuetify(vuetifySetting);
